require('./$.set-species')('Array');


/*****************
 ** WEBPACK FOOTER
 ** /home/rengasturku/nettivanne/~/babel-core/~/core-js/modules/es6.array.species.js
 ** module id = 490
 ** module chunks = 0 1 4 5 6 7 8
 **/